/*
 * Releasit loads the TikTok pixel (window.ttq) and sends PageView + InitiateCheckout
 * + Purchase, but not ViewContent or AddToCart. This sends those two through the
 * pixel Releasit already loaded, so nothing is counted twice and no second base
 * code is needed in the theme.
 */
(function () {
  var CURRENCY = 'RSD';

  function withTtq(cb, tries) {
    tries = tries || 0;
    if (window.ttq && typeof window.ttq.track === 'function') return cb(window.ttq);
    if (tries < 60) setTimeout(function () { withTtq(cb, tries + 1); }, 500);
  }

  function track(name, params) {
    withTtq(function (ttq) {
      try { ttq.track(name, params); } catch (e) {}
    });
  }

  function viewContent() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var product = meta && meta.product;
    if (!product || !product.variants || !product.variants.length) return;
    var wanted = new URLSearchParams(window.location.search).get('variant');
    var variant = product.variants[0];
    if (wanted) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === wanted) { variant = product.variants[i]; break; }
      }
    }
    track('ViewContent', {
      content_id: String(product.id),
      content_type: 'product',
      content_name: variant.name || document.title,
      value: variant.price / 100,
      currency: CURRENCY
    });
  }

  function addedToCart(item) {
    if (!item || !item.product_id) return;
    var qty = item.quantity || 1;
    track('AddToCart', {
      content_id: String(item.product_id),
      content_type: 'product',
      content_name: item.product_title || item.title,
      quantity: qty,
      value: (item.price / 100) * qty,
      currency: CURRENCY
    });
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      var promise = nativeFetch.apply(this, arguments);
      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        promise.then(function (response) {
          if (!response.ok) return;
          response.clone().json().then(function (data) {
            if (data && data.items) data.items.forEach(addedToCart);
            else addedToCart(data);
          }).catch(function () {});
        }).catch(function () {});
      }
      return promise;
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', viewContent);
  else viewContent();
})();
